/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SiteLink } from '../../components';
import { FaAngleLeft } from 'react-icons/fa';
import { useHistoryStore } from '../../components';
import style from './backButtonStyle';

export function BackButton(props) {

  const history = useHistoryStore();

  function goBack(e) {
    history.pop();
  }

  // Debug logging
  console.log('BackButton - history:', history.history);
  console.log('BackButton - last():', history.last());

  if (history.last()) {
    return (<SiteLink css={style.button} title="Go Back" to={history.last()} onClick={goBack} >
      <FaAngleLeft />
    </SiteLink>)
  } else {
    // Show a test button when no history to verify visibility
    return (
      <div css={style.button} title="No Back History Available" style={{opacity: 0.5}}>
        <FaAngleLeft />
      </div>
    );
  }
}